export const CarriersColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Название',
        key: 'name',
        withHint: true,
    },
    {
        name: 'БИН',
        key: 'bin',
    },
    {
        name: 'Контактное имя',
        key: 'contact_name',
        withHint: true,
    },
    {
        name: 'Контактный номер',
        key: 'contact_phone',
    },
    {
        name: 'Номер и дата договора',
        key: 'contract_number',
    },
    {
        name: 'Тип поставщика',
        key: 'activity',
    },
    {
        name: 'Менее 3х тонн',
        key: 'typeTons'
    },
    {
        name: 'Дата создания',
        key: 'created_at',
    },
    {
        name: 'Статус',
        key: 'status',
    },
]

export const CarriersSendColumns = [
    {
        name: '№',
        key: 'index',
    },
    {
        name: 'ФИО водителя',
        key: 'full_name',
    },
    {
        name: 'Марка/госномер автотранспорта',
        key: 'car',
    },
]
